import './OrderProductTable.scss'

interface Product {
    id: number;
    order_id: number;
    discount_price: number | null;
    status: number | null;
    quantity_product: number;
    actual_quantity?: number;
    name_product: string;
    slug_product: string;
    avatar_product: string;
    price_product: number;
}

interface OrderProductTableProps {
    products?: Product[];
    orderStatus?: string;
}

export default function OrderProductTable({ products = [], orderStatus }: OrderProductTableProps) {
    const showActualQty = orderStatus === "4" || orderStatus === "5";
    return (
        <div className="MuiPaper-root MuiTableContainer-root styles_tableItem__RSEhy MuiPaper-elevation4 MuiPaper-rounded order-product-table">
            <div className="MuiPaper-root MuiAccordion-root Mui-expanded MuiAccordion-rounded MuiPaper-elevation1 MuiPaper-rounded">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12 !mb-[32px]">

                    {/* TABLE */}
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                        <table className="MuiTable-root styles_table__2_Acb">
                            <thead className="MuiTableHead-root">
                                <tr className="MuiTableRow-root MuiTableRow-head">
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignLeft">Sản phẩm</th>
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignLeft"></th>
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignLeft">SL đặt</th>
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignLeft" style={{ color: '#e88438', fontWeight: 700 }}>SL thực nhận</th>
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignRight">Đơn giá(đ)</th>
                                    <th className="MuiTableCell-root MuiTableCell-head styles_tableCellText__wwNVp MuiTableCell-alignRight">Tổng Cộng(đ)</th>
                                </tr>
                            </thead>

                            <tbody className="MuiTableBody-root">
                                {(products && products.length > 0) ? products.map((product) => (
                                    <tr key={product.id} className="MuiTableRow-root styles_tableRow__nHHKk">
                                        <td className="MuiTableCell-root MuiTableCell-body styles_imgProduct__F3j0T">
                                            <a
                                                className="styles_mobile_rootBase__8z7PQ"
                                                href={`/product/${product.slug_product}`}
                                            >
                                                <img
                                                    alt={product.name_product}
                                                    src={product.avatar_product || "https://img-proxy.thuocsi.vn/thuocsi-live/web/static/images/default_store.svg?size=origin"}
                                                    style={{ objectFit: "contain", width: "68px", height: "68px" }}
                                                />
                                            </a>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_wrapName__wNVas">
                                            <div className="styles_wrapInfoText__YuEfm">
                                                <div>
                                                    <span className="styles_wrapNameWithGift__xUBAd">
                                                        <a
                                                            className="styles_mobile_rootBase__8z7PQ styles_prd_name_text__3YAq6 styles_hover_green__M7oiD"
                                                            href={`/product/${product.slug_product}`}
                                                        >
                                                            {product.name_product}
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-alignLeft">
                                            {product.quantity_product}
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-alignLeft" style={{ color: '#e88438', fontWeight: 700 }}>
                                            {showActualQty ? (product.actual_quantity ?? product.quantity_product) : 0}
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_product_price__5e3WG styles_widthSalePrice__IGWGl MuiTableCell-alignRight">
                                            <div>
                                                {(product.discount_price ?? product.price_product).toLocaleString()}
                                            </div>
                                            {product.discount_price && (
                                                <div className="text-[12px] line-through text-gray-400">
                                                    {product.price_product.toLocaleString()}
                                                </div>
                                            )}
                                        </td>

                                        <td className="MuiTableCell-root MuiTableCell-body styles_product_price__5e3WG styles_widthSalePrice__IGWGl MuiTableCell-alignRight">
                                            {showActualQty
                                                ? ((product.discount_price ?? product.price_product) * (product.actual_quantity ?? product.quantity_product)).toLocaleString()
                                                : '0'
                                            }
                                        </td>
                                    </tr>
                                )) : (
                                    <tr className="MuiTableRow-root">
                                        <td colSpan={6} className="MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter">
                                            Không có sản phẩm nào
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
